import { render, staticRenderFns } from "./DataImport.vue?vue&type=template&id=eb25974a"
import script from "./DataImport.vue?vue&type=script&lang=ts"
export * from "./DataImport.vue?vue&type=script&lang=ts"
import style0 from "./DataImport.vue?vue&type=style&index=0&id=eb25974a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports